import * as React from "react";

// Shown in place of Message, Request resume and Invite for a staged RPO
// candidate (the server sends rpo_managed: true). The recruiter handles
// contact with these applicants; the server refuses those actions anyway.
export const RPO_MANAGED_LABEL = "Managed by your DirectDental recruiter";

interface RpoManagedNoticeProps {
  className?: string;
  style?: React.CSSProperties;
}

const RpoManagedNotice: React.FC<RpoManagedNoticeProps> = ({ className = "text-muted small", style }) => (
  <span className={className} style={style} data-testid="rpo-managed-notice">
    <i className="fa fa-user-circle me-1" aria-hidden="true"></i>
    {RPO_MANAGED_LABEL}
  </span>
);

export default RpoManagedNotice;
